module.exports = __webpack_public_path__ + "img/profile_box_coach_place_name.9ccc7b72.svg";